export const customersStopStatus = [`created`, `scheduled`, `on_route`, `completed`, `canceled`] as const;

export type StatusHistoryTypes = (typeof customersStopStatus)[number];

export type StatusHistory = Array<{
  id: StatusHistoryTypes;
  label?: string;
}>;
